import { Col, Row } from "reactstrap";
import NavHeader from "../components/NavHeader";
import ThemeForm from "../forms/app/ThemeForm";
import SideBar from "../components/app/SideBar";
import Previews from "../components/app/Previews";
import { useEffect } from "react";

type AppThemeDesignerPageProps = {
  isWhiteLabel?: boolean;
};

export default function AppThemeDesignerPage({
  isWhiteLabel,
}: AppThemeDesignerPageProps) {
  useEffect(() => {
    document.title = isWhiteLabel
      ? "Order App WhiteLabel Theme Designer"
      : "Order App Theme Designer";
  }, [isWhiteLabel]);

  return (
    <ThemeForm>
      <NavHeader />
      <Row>
        <Col xs={12} sm={12} md={5} lg={4} xl={2}>
          <SideBar />
        </Col>
        <Col xs={12} sm={12} md={7} lg={8} xl={10}>
          <Previews />
        </Col>
      </Row>
    </ThemeForm>
  );
}
